import { Flex } from 'antd';
import Surveys from '@/assets/icons/star-01.svg?react';
import Icon from '@ant-design/icons';
import styles from './score.module.scss';

interface ScoreProps {
  score: number | null | undefined;
  className?: string;
}

export function Score({ score, className }: ScoreProps) {
  const getScoreColor = (score: number): string => {
    if (score >= 1 && score <= 4) return styles.lowRate;
    if (score >= 5 && score <= 7) return styles.mediumRate;
    if (score >= 8 && score <= 10) return styles.highRate;
    return styles.noRate;
  };

  const formatScore = (value: number) =>
    Number.isInteger(value) ? value : Math.round(value * 10) / 10;

  const scoreColor = score == null ? styles.noRate : getScoreColor(score);

  return (
    <Flex gap={7} align="center" className={className}>
      <div
        className={styles.iconWrapper}
        style={{ backgroundColor: scoreColor }}
        data-testid="score-icon"
      >
        <Icon component={() => <Surveys fill="white" height="10" width="10" />} />
      </div>

      {score != null && <span className={styles.score}>{formatScore(score)}/10</span>}
    </Flex>
  );
}
